import { rtkApi } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import { IStudentAboutStaffResponse } from './types';

const staffApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getStaffById: build.query<IStudentAboutStaffResponse, string>({
      query: (staffId) => `/student/about-staff/${staffId}`,
      transformResponse: (response: SuccessApiResponse<IStudentAboutStaffResponse>) =>
        response.data,
    }),
  }),
});

export const { useGetStaffByIdQuery } = staffApi;
